import './RoleTag.scss';

type TagType = 'decisionLevel' | 'functionalGroup' | 'marketTheme';

// Decision Level colors
const DECISION_LEVEL_COLORS: Record<string, string> = {
  executive: 'teal',
  'functional leader': 'green',
  'school leadership': 'blue',
  'operational support': 'yellow',
  practitioner: 'yellow',
};

// Functional Group colors
const FUNCTIONAL_GROUP_COLORS: Record<string, string> = {
  'district administration': 'orange',
  'finance and procurement': 'yellow',
  'human resources': 'green',
  technology: 'blue',
  operations: 'teal',
  'curriculum and instruction': 'purple',
  'special education': 'pink',
  'student services': 'cyan',
};

// Market Theme colors - all use gray for now
const MARKET_THEME_COLORS: Record<string, string> = {};

interface RoleTagProps {
  type: TagType;
  value: string;
  size?: 'small' | 'normal';
  bg?: 'hard' | 'medium';
  onClick?: () => void;
}

function getColorMap(type: TagType): Record<string, string> {
  switch (type) {
    case 'decisionLevel':
      return DECISION_LEVEL_COLORS;
    case 'functionalGroup':
      return FUNCTIONAL_GROUP_COLORS;
    case 'marketTheme':
      return MARKET_THEME_COLORS;
  }
}

export function RoleTag({ type, value, size = 'normal', bg = 'hard', onClick }: RoleTagProps) {
  const colorMap = getColorMap(type);
  const color = colorMap[value.toLowerCase()] || 'gray';
  const sizeClass = size === 'small' ? ' role-tag--small' : '';
  const bgClass = bg === 'medium' ? ' role-tag--bg-medium' : '';

  return (
    <span
      className={`role-tag role-tag--${color}${sizeClass}${bgClass}${onClick ? ' role-tag--clickable' : ''}`}
      onClick={onClick}
    >
      {value}
    </span>
  );
}
